import React, { useEffect, useMemo, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { MUTATION } from '../../../gql-operations';
import { clearAuthTokens } from '../../../utils/authSession';
import { parseRaycastRequest, raycastCallback, raycastLoginPath } from './raycastAuth';

export default function RaycastAuthPage() {
    const { t } = useTranslation();
    const location = useLocation();
    const request = useMemo(() => parseRaycastRequest(location.search), [location.search]);
    const [failed, setFailed] = useState(false);
    const [createCode] = useMutation(MUTATION.CREATE_EXTENSION_AUTH_CODE);
    const signedIn = Boolean(localStorage.getItem('token') || localStorage.getItem('refreshToken'));

    useEffect(() => {
        if (!request || !signedIn) return;
        let cancelled = false;
        const login = () => {
            clearAuthTokens();
            window.location.replace(raycastLoginPath(location.search));
        };
        setFailed(false);
        const { state, ...data } = request;
        createCode({ variables: { data } }).then(result => {
            if (cancelled) return;
            const payload = result.data?.createExtensionAuthCode;
            if (payload?.__typename === 'ExtensionAuthCodePayload' && payload.code) {
                window.location.replace(raycastCallback(payload.code, state));
            } else {
                setFailed(true);
            }
        }).catch(error => {
            if (cancelled) return;
            if (error.graphQLErrors?.some(item => item.extensions?.code === 'UNAUTHENTICATED')) login();
            else setFailed(true);
        });
        return () => { cancelled = true; };
    }, [createCode, location.search, request, signedIn]);

    if (request && !signedIn) return <Redirect to={raycastLoginPath(location.search)} />;
    const message = !request ? t('auth:raycastInvalidRequest')
        : failed ? t('auth:raycastConnectionFailed') : t('auth:raycastReturning');
    return (
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#f8f9f7', color: '#161a17' }}>
            <div style={{ maxWidth: 400, textAlign: 'center' }}>
                <h1>{t('auth:raycastConnecting')}</h1>
                <p role="status">{message}</p>
            </div>
        </main>
    );
}
